import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Input, Modal, ModalBody, Spinner } from 'reactstrap'
import { AiOutlineInbox } from 'react-icons/ai'
import moment from 'moment'
import style from '../../assets/css/input.module.css'
import styleTrans from '../../assets/css/transaksi.module.css'
import NewNavbar from '../../components/NewNavbar'
import monitoring from '../../redux/actions/monitoring'
import pengadaan from '../../redux/actions/pengadaan'
import disposal from '../../redux/actions/disposal'
import mutasi from '../../redux/actions/mutasi'
import stock from '../../redux/actions/stock'
import TrackingPengadaan from '../../components/Pengadaan/TrackingPengadaan'
import TrackingDisposal from '../../components/Disposal/TrackingDisposal'
import TrackingMutasi from '../../components/Mutasi/TrackingMutasi'
import TrackingStock from '../../components/Stock/TrackingStock'

const listTransaksi = [
    { value: 'all', label: 'Semua Transaksi' },
    { value: 'pengadaan', label: 'Pengadaan Aset' },
    { value: 'disposal', label: 'Disposal Aset' },
    { value: 'mutasi', label: 'Mutasi Aset' },
    { value: 'stock', label: 'Stock Opname' }
]

const listStatus = [
    { value: 'draft', label: 'Draft' },
    { value: 'progress', label: 'On Progress' },
    { value: 'reject', label: 'Reject' },
    { value: 'finish', label: 'Finish' }
]

const listLimit = [10, 20, 50, 100]

class MonitoringTransaksi extends Component {
    state = {
        sidebarOpen: false,
        transaksi: 'all',
        status: 'progress',
        time1: moment().startOf('month').format('YYYY-MM-DD'),
        time2: moment().format('YYYY-MM-DD'),
        search: '',
        limit: 10,
        modalTrack: false,
        tipeTrack: '',
        loadingTrack: false
    }

    componentDidMount() {
        this.getDataMonitoring({ page: 1 })
    }

    prosesSidebar = (val) => {
        this.setState({ sidebarOpen: val })
    }

    goRoute = (val) => {
        this.props.history.push(`/${val}`)
    }

    getDataMonitoring = async (value) => {
        const token = localStorage.getItem('token')
        const { transaksi, status, time1, time2, search, limit } = { ...this.state, ...value }
        const params = {
            transaksi: transaksi,
            status: status,
            search: search,
            limit: limit,
            page: value.page === undefined ? 1 : value.page
        }
        // filter tanggal hanya untuk selain on progress
        if (status !== 'progress' && time1 !== '' && time2 !== '') {
            params.time1 = time1
            params.time2 = time2
        }
        await this.props.getMonitoringTransaksi(token, params)
    }

    changeFilter = (val) => {
        this.setState(val)
        this.getDataMonitoring({ ...val, page: 1 })
    }

    onSearch = (e) => {
        this.setState({ search: e.target.value })
        if (e.key === 'Enter') {
            this.getDataMonitoring({ search: e.target.value, page: 1 })
        }
    }

    changePage = (val) => {
        const { page } = this.props.monitoring
        this.getDataMonitoring({ page: page.currentPage + val })
    }

    openTracking = async (item) => {
        const token = localStorage.getItem('token')
        this.setState({ loadingTrack: true })
        try {
            if (item.transaksi === 'pengadaan') {
                await this.props.getDetailPengadaan(token, item.no_transaksi)
            } else if (item.transaksi === 'disposal') {
                await this.props.getDetailDisposal(token, item.no_transaksi, 'pengajuan')
            } else if (item.transaksi === 'mutasi') {
                await this.props.getDetailMutasi(token, item.no_transaksi)
            } else {
                await this.props.getDetailStock(token, item.no_transaksi)
            }
            this.setState({ loadingTrack: false, tipeTrack: item.transaksi, modalTrack: true })
        } catch (error) {
            this.setState({ loadingTrack: false })
        }
    }

    closeTracking = () => {
        this.setState({ modalTrack: false })
    }

    render() {
        const { dataMonitoring, page, isLoading, isError } = this.props.monitoring
        const { transaksi, status, time1, time2, search, limit, tipeTrack } = this.state
        const dataList = dataMonitoring || []
        const startNo = page.currentPage === undefined ? 1 : ((page.currentPage - 1) * page.limitPerPage) + 1
        return (
            <>
                <div className={styleTrans.app}>
                    <NewNavbar handleSidebar={this.prosesSidebar} handleRoute={this.goRoute} />

                    <div className={`${styleTrans.mainContent} ${this.state.sidebarOpen ? styleTrans.collapsedContent : ''}`}>
                        <h2 className={styleTrans.pageTitle}>Monitoring Transaksi</h2>
                        <div className={styleTrans.searchContainer}>
                            <div className='rowCenter'>
                                <select value={transaksi} onChange={e => this.changeFilter({ transaksi: e.target.value })} className={styleTrans.searchInput}>
                                    {listTransaksi.map(item => {
                                        return (
                                            <option key={item.value} value={item.value}>{item.label}</option>
                                        )
                                    })}
                                </select>
                                <select value={status} onChange={e => this.changeFilter({ status: e.target.value })} className={`${styleTrans.searchInput} ml-2`}>
                                    {listStatus.map(item => {
                                        return (
                                            <option key={item.value} value={item.value}>{item.label}</option>
                                        )
                                    })}
                                </select>
                                <select value={limit} onChange={e => this.changeFilter({ limit: parseInt(e.target.value) })} className={`${styleTrans.searchInput} ml-2`}>
                                    {listLimit.map(item => {
                                        return (
                                            <option key={item} value={item}>Show {item}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <input
                                type="text"
                                placeholder="Search no ajuan / area..."
                                onChange={this.onSearch}
                                onKeyPress={this.onSearch}
                                value={search}
                                className={styleTrans.searchInput}
                            />
                        </div>
                        {status !== 'progress' && (
                            <div className={styleTrans.searchContainer}>
                                <div className='rowCenter'>
                                    <text className='mr-2'>Tanggal Ajuan :</text>
                                    <Input
                                        type="date"
                                        className="inputRinci"
                                        value={time1}
                                        onChange={e => this.setState({ time1: e.target.value })}
                                    />
                                    <text className='mr-1 ml-1'>To</text>
                                    <Input
                                        type="date"
                                        className="inputRinci"
                                        value={time2}
                                        onChange={e => this.setState({ time2: e.target.value })}
                                    />
                                    <Button
                                        disabled={time1 === '' || time2 === ''}
                                        color='primary'
                                        onClick={() => this.getDataMonitoring({ page: 1 })}
                                        className='ml-1'>
                                        Go
                                    </Button>
                                </div>
                            </div>
                        )}

                        <table className={styleTrans.table}>
                            <thead>
                                <tr>
                                    <th>NO</th>
                                    <th>TRANSAKSI</th>
                                    <th>NO.AJUAN</th>
                                    <th>KODE AREA</th>
                                    <th>AREA</th>
                                    <th>TANGGAL AJUAN</th>
                                    <th>UMUR (HARI)</th>
                                    <th>JUMLAH ITEM</th>
                                    <th>LAST STAGE</th>
                                    <th>NEXT STAGE</th>
                                    <th>LAST HISTORY</th>
                                    <th>LAST UPDATE</th>
                                    <th>OPSI</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataList.map((item, index) => {
                                    return (
                                        <tr key={`${item.transaksi}-${item.no_transaksi}`}>
                                            <td>{startNo + index}</td>
                                            <td>{(listTransaksi.find(x => x.value === item.transaksi) || {}).label}</td>
                                            <td>{item.no_transaksi}</td>
                                            <td>{item.kode_plant}</td>
                                            <td>{item.area}</td>
                                            <td>{item.tanggal === null ? '-' : moment(item.tanggal).format('DD MMMM YYYY')}</td>
                                            <td style={status === 'progress' && item.umur > 30 ? { color: '#dc3545', fontWeight: 600 } : {}}>{item.umur === null ? '-' : item.umur}</td>
                                            <td>{item.jumlah_item}</td>
                                            <td>{item.last_stage}</td>
                                            <td>{item.next_stage}</td>
                                            <td>{item.last_history}</td>
                                            <td>{item.last_update === null ? '-' : moment(item.last_update).format('DD MMMM YYYY')}</td>
                                            <td>
                                                <Button className='mt-1' color='warning' onClick={() => this.openTracking(item)}>Tracking</Button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        {dataList.length === 0 && (
                            <div className={style.spinCol}>
                                <AiOutlineInbox size={50} className='secondary mb-4' />
                                <div className='textInfo'>{isError ? 'Gagal mengambil data, coba lagi' : 'Data ajuan tidak ditemukan'}</div>
                            </div>
                        )}
                        {dataList.length > 0 && (
                            <div className='rowCenter mt-3 mb-4'>
                                <text className='mr-3'>Halaman {page.currentPage} dari {page.pages} ({page.count} ajuan)</text>
                                <Button color='primary' className='mr-2' disabled={page.currentPage <= 1} onClick={() => this.changePage(-1)}>Prev</Button>
                                <Button color='primary' disabled={page.currentPage >= page.pages} onClick={() => this.changePage(1)}>Next</Button>
                            </div>
                        )}
                    </div>
                </div>
                <Modal isOpen={this.state.modalTrack} toggle={this.closeTracking} size="xl" className='xl'>
                    {tipeTrack === 'pengadaan' ? (
                        <TrackingPengadaan />
                    ) : tipeTrack === 'disposal' ? (
                        <TrackingDisposal />
                    ) : tipeTrack === 'mutasi' ? (
                        <TrackingMutasi />
                    ) : tipeTrack === 'stock' && (
                        <TrackingStock />
                    )}
                    <hr />
                    <div className="modalFoot ml-3">
                        <div></div>
                        <div className="btnFoot">
                            <Button color="primary" onClick={this.closeTracking}>
                                Close
                            </Button>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={isLoading || this.state.loadingTrack} size="sm">
                    <ModalBody>
                        <div>
                            <div className={style.cekUpdate}>
                                <Spinner />
                                <div>Waiting....</div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = state => ({
    monitoring: state.monitoring
})

const mapDispatchToProps = {
    getMonitoringTransaksi: monitoring.getMonitoringTransaksi,
    getDetailPengadaan: pengadaan.getDetail,
    getDetailDisposal: disposal.getDetailDisposal,
    getDetailMutasi: mutasi.getDetailMutasi,
    getDetailStock: stock.getDetailStock
}

export default connect(mapStateToProps, mapDispatchToProps)(MonitoringTransaksi)
